module.exports = __webpack_public_path__ + "static/media/ActorConversion.c554a9c9.wav";